import { lazy, Suspense } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Loader from "../components/shared/loader/loader";
import ThemeLayout from "../components/ThemeLayout";
import RefreshAuth from "./RefreshAuth";

import "react-toastify/dist/ReactToastify.css";
import "../ui-kit/typography/styles.css";

const TwoFASteps = lazy(
  () => import("../containers/Authentication/Login/LoginView/TwoFAView/TwoFASteps"),
);
const AffiliateSetup = lazy(() => import("./AffiliateSetup"));
const AuthWrapper = lazy(() => import("./AuthWrapper"));
const Authentication = lazy(() => import("./Authentication"));
const Enrollment = lazy(() => import("./Enrollment"));
const ResetMfa = lazy(() => import("./ResetMfa"));
const SetMfaPage = lazy(() => import("./SetMfa"));

const AppContainer = () => {
  const { activeUser } = useSelector((state: RootStateOrAny) => state.users);

  const setRoute = () => {
    if (activeUser.access_token && localStorage.getItem("landingPage")) {
      return "/" + localStorage.getItem("landingPage");
    } else {
      return "/";
    }
  };

  return (
    <ThemeLayout>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/login" element={<Authentication />} />
            <Route path="/auth/setup" element={<TwoFASteps />} />
            <Route path="/secure-urls/:token" element={<Navigate to={setRoute()} />} />
            <Route path="/enrollment" element={<Enrollment />} />
            <Route path="/setup" element={<AffiliateSetup />} />
            <Route path="/reset-mfa" element={<ResetMfa />} />
            <Route path="/set-mfa" element={<SetMfaPage />} />
            <Route path="/*" element={<AuthWrapper />} />
          </Routes>
        </Suspense>
        <ToastContainer />
      </BrowserRouter>
      <RefreshAuth />
    </ThemeLayout>
  );
};

export default AppContainer;
